module.exports = __webpack_public_path__ + "img/robot_5.af4c6782.png";